import { render, staticRenderFns } from "./newActivityInfo.vue?vue&type=template&id=84701580&scoped=true"
import script from "./newActivityInfo.vue?vue&type=script&lang=js"
export * from "./newActivityInfo.vue?vue&type=script&lang=js"
import style0 from "./newActivityInfo.vue?vue&type=style&index=0&id=84701580&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84701580",
  null
  
)

export default component.exports